<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField'>
    <RF-Input v-show='tipo === "input"'
      :data-time="time"

      :cpntStatus='cpntStatus'
      :cpntId='cpntId + "-input"'
      :cpntTabIndex='cpntTabIndex'
      :cpntClassDivField='cpntClassDivField'
      :cpntNome='cpntNome'
      :cpntValue='value'
      :cpntAutoComplete='cpntAutoComplete'
      :cpntDisabled='cpntDisabled'
      :cpntMostrar='cpntMostrar'
      :cpntAutoFocus='cpntAutoFocus'
      :cpntMensagem='cpntMensagem'
      :cpntMensagemTipo='cpntMensagemTipo'
      :cpntPlaceholder='cpntPlaceholder'
      :cpntExplica='cpntExplica'

      :cpntOnKeyUp='cpntBuscaAutoOnKeyUp'
      :cpntOnChange='cpntBuscaAutoOnChangeInput'
      :cpntOnKeyPressEnter='cpntBuscaAutoOnKeyPressEnterInput'
      ref='input'
    ></RF-Input>

    <RF-Input-Complite v-show="tipo === 'auto'" v-if="where !== null"
      :data-time="time"

      :cpntStatus='cpntStatus'
      :cpntId='cpntId + "-auto"'
      :cpntTabIndex='cpntTabIndex'
      :cpntClassDivField='cpntClassDivField'
      :cpntNome='cpntNome'
      :cpntValue='value'
      :cpntAutoComplete='cpntAutoComplete'
      :cpntDisabled='cpntDisabled'
      :cpntMostrar='cpntMostrar'
      :cpntAutoFocus='cpntAutoFocus'
      :cpntMensagem='cpntMensagem'
      :cpntMensagemTipo='cpntMensagemTipo'
      :cpntPlaceholder='cpntPlaceholder'
      :cpntExplica='cpntExplica'
      :cpntAddButForm='cpntAddButForm'

      :cpntKeyMostra='cpntKeyMostra'
      :cpntValueRef='valueRef'
      :cpntRouter='cpntRouter'
      :cpntMethod='cpntMethod'
      :cpntField='cpntField'
      :cpntFieldVirtual='cpntFieldVirtual'
      :cpntWhere='where'
      :cpntTipoOrder='cpntTipoOrder'
      :cpntOrder='cpntOrder'

      :cpntOnRealizaBusca="cpntBuscaAutoOnRealizaBusca"
      :cpntOnChange='cpntBuscaAutoOnChangeValor'
      ref='auto'
    ></RF-Input-Complite>
  </div>
</template>

<style scoped>
  .rf-input-group > div {
    width: 100%;
  }
</style>

<script>
  export default {
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntTabIndex: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return 1
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntValueRef: {
        required: true,
        type: [ String, Number ]
      },
      cpntAutoComplete: {
        type: String,
        required: false,
        default: 'off'
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntAutoFocus: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },

      cpntRouter: {
        type: String,
        required: true
      },
      cpntMethod: {
        type: String,
        required: false,
        default: function () {
          return 'GET'
        }
      },
      cpntField: {
        type: Object,
        required: true
      },
      cpntFieldVirtual: {
        type: Array,
        required: false,
        default: function () {
          return null
        }
      },
      cpntWhere: {
        type: [ Object, String ],
        required: false,
        default: function () {
          return {}
        }
      },
      cpntTipoOrder: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },
      cpntOrder: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      },
      cpntKeyMostra: {
        type: Array,
        required: true
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntAddButForm: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnRealizaBusca: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: 0,
        statusGeral: '',
        tipo: 'input',
        value: '',
        valueRef: '',
        where: null,
        entrer: false,
        contador: 0
      }
    },
    components: {
      'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'RF-Input-Complite': () => import('@/components/rf-geral/input-complite/RF-Input-Complite.vue')
    },
    mounted: function () {
      this.cpntBuscaAutoIniciar()
    },
    methods: {
      cpntBuscaAutoIniciar: function () {
        if (typeof this.cpntWhere === 'string') {
          switch (this.cpntWhere) {
            case 'ven-pro':
            case 'pro-form':
              this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'produto', o: 's.ft', v: '' } ] }
              break
          }
        } else {
          this.where = this.cpntWhere
        }
      },
      cpntBuscaAutoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntBuscaAutoOnChangeInput: function (value) {
        // SETA O STATUS DA TELA
        this.value = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INFORMA QUE ESTÁ REALIZANDO UMA BUSCA
        this.cpntBuscaAutoOnRealizaBusca(value)
      },
      cpntBuscaAutoOnKeyPressEnterInput: function () {
        this.cpntBuscaAutoOnChange(this.contador)
      },
      cpntBuscaAutoOnChangeValor: function (value) {
        this.cpntOnChange(value, this.cpntId, this.tipo)
      },
      onFocusField: function () {
        this.cpntBuscaAutoDarFocusCampo(this.tipo)
      },
      cpntBuscaAutoDarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 20) {
          // PEGA A CHAVE DO CAMPO
          var chave = Object.keys(this.$refs[campo].$refs)[0]
  
          // DA O FOCUS NO CAMPO
          this.$refs[campo].$refs[chave].focus()

          // VERIFICA SE A CHAVE JÁ ESTÁ COM FOCUS
          if (document.activeElement.id !== chave) {
            setTimeout(() => { this.cpntBuscaAutoDarFocusCampo(campo, (tentativa + 1)) }, 100)
          }
        }
      },
      cpntBuscaAutoOnRealizaBusca: function (valor) {
        // // VERIFICA SE TEM QUE ALTERAR PARA INPUT
        // if (valor === '') {
        //   this.cpntBuscaAutoOnKeyUp()
        // }

        // INFORMA O PAI QUE FOI FEITO UMA ALTERAÇÃO NO INPUT
        if (this.cpntOnRealizaBusca !== null) {
          this.cpntOnRealizaBusca(valor)
        }
      },
      cpntBuscaAutoOnKeyUp: function () {
        // SETA O STATUS DA TELA
        this.tipo = 'input'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // DA O FOCUS NO CAMPO
        this.cpntBuscaAutoDarFocusCampo('input')

        // SOMA O CONTADOR
        this.contador++

        // COPIA O VALOR CONTADO
        var contado = JSON.parse(JSON.stringify(this.contador))

        // CHAMA A FUNÇÃO PARA BUSCAR O PRODUTO
        setTimeout(() => { this.cpntBuscaAutoAlterarTipoParaAuto(contado) }, 150)
      },
      cpntBuscaAutoOnChange: function (contado) {
        if (this.contador === contado && this.value.length >= 2) {
          // SOMA O CONTADOR
          this.contador++

          // SETA O QUERY GET QUE SERÁ REALIZADO
          var queryGet = { type: 'list', limit: { row: 0, qty: 1 }, field: this.cpntField }

          // VERIFICA O WHERE QUE DEVE SER FEITO
          if (typeof this.cpntWhere === 'string') {
            switch (this.cpntWhere) {
              case 'ven-pro':
                queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'cod_barra', o: '=', v: this.value } ] }
                break
            }
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(this.cpntRouter, this.cpntMethod, queryGet, (apiSuccess) => {
            switch (apiSuccess.data.length) {
              case 1:
                this.cpntBuscaAutoOnChangeValor(apiSuccess.data[0])
                break

              default:
                this.cpntBuscaAutoAlterarTipoParaAuto(this.contador)
                break
            }
          }, this.cpntBuscaAutoSetarStatusGeral)
        }
      },
      cpntBuscaAutoAlterarTipoParaAuto: function (contado) {
        if (this.contador === contado && this.value.length >= 2) {
          // SOMA O CONTADOR
          this.contador++

          // SETA O WHERE PARA O AUTOCOMPLITE
          if (typeof this.cpntWhere === 'string') {
            switch (this.cpntWhere) {
              case 'ven-pro':
                this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'produto', o: 's.ft', v: '' } ] }
                break
            }
          }

          // SETA O STATUS DA TELA
          this.tipo = 'auto'

          // LIMPA O VALOR REF
          this.valueRef = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // DA O FOCUS NO CAMPO
          this.cpntBuscaAutoDarFocusCampo('auto')

          // REALIZA A BUSCA DO AUTOCOMPLITE
          this.$refs.auto.getAutoComplite()
        }
      }
    },
    watch: {
      cpntValue: function () {
        if (this.cpntValue !== this.value) {
          this.value = this.cpntValue
        }

        // VERIFICA SE TEM QUE ALTERAR PARA INPUT
        if (this.value === '' && this.tipo !== 'input') {
          this.cpntBuscaAutoOnKeyUp()
        }
      },
      cpntValueRef: function () {
        if (this.cpntValueRef !== this.valueRef) {
          this.valueRef = this.cpntValueRef
        }
      }
    }
  }
</script>
